/*
 * @Author: YuanYuan
 * @Date: 2023-11-06 11:24:13
 * @LastEditTime: 2026-03-13 10:46:05
 * @description: 通用校验规则
 */
import i18n from '@/i18n'
import Regexp from './regexp'
import { isArray, uniq } from 'lodash-es'

const findReg = key => {
  const regItem = Regexp.find(n => n.name === key)
  return regItem.value
}

export default [
  // 输入框必须输入内容，传入 true 时，trim 字符串（例如textarea时，input时可以直接绑定v-model.trim）
  {
    name: 'RequiredVal',
    value: (msg = i18n.t('common.cannotEmpty'), valTrim = true) => {
      if (valTrim) {
        const validator = (_, value, cb) => {
          if (Array.isArray(value)) {
            if (value.length) {
              cb()
            } else {
              cb(new Error(msg))
            }
          } else {
            if (value !== undefined && String(value) && String(value).trim()) {
              cb()
            } else {
              cb(new Error(msg))
            }
          }
        }
        return {
          required: true,
          validator
        }
      } else {
        return {
          required: true,
          message: msg
        }
      }
    }
  },
  // 不包含空格
  {
    name: 'NoSpace',
    value: (msg = i18n.t('common.noSpace')) => {
      const validator = (_, value, cb) => {
        if (/\s/.test(value)) {
          cb(new Error(msg))
        } else {
          cb()
        }
      }
      return { validator }
    }
  },
  // 校验域名- waap中域名校验规则F
  {
    name: 'NormalDomain',
    value: (msg = i18n.t('common.formatError')) => {
      return {
        pattern: findReg('NormalDomain'),
        message: msg,
        trigger: 'blur'
      }
    }
  },
  // 泛域名
  {
    name: 'WildDomain',
    value: (msg = i18n.t('common.formatError')) => {
      return {
        pattern: findReg('WildDomain'),
        message: msg,
        trigger: 'blur'
      }
    }
  },
  // 证书申请的域名
  {
    name: 'CertDomain',
    value: (msg = i18n.t('common.formatError')) => {
      return {
        pattern: findReg('CertDomain'),
        message: msg,
        trigger: 'blur'
      }
    }
  },
  // 校验端口
  {
    name: 'Port',
    value: (msg = i18n.t('common.enterValidPort')) => {
      return {
        pattern: findReg('Port'),
        message: msg,
        trigger: 'blur'
      }
    }
  },
  // 输入多个域名 WildDomain 正则，多个用sep分隔
  {
    name: 'MultiWildDomain',
    value: (sep = ';', maxlength = 100, msg = i18n.t('common.formatError')) => {
      const validator = (_, value, cb) => {
        const valueStr = String(value)
        if (valueStr) {
          const valueList = valueStr.split(sep)
          if (valueList.every(n => findReg('WildDomain').test(n))) {
            if(maxlength) {
              if(valueList.length > maxlength) {
                cb(new Error(i18n.t('common.noExceedLen', { len: maxlength })))
              } else {
                cb()
              }
            } else {
              cb()
            }
          } else {
            cb(new Error(msg))
          }
        } else {
          cb()
        }
      }
      return { validator }
    }
  },
  // 输入多个域名/IP，多个用sep分隔
  {
    name: 'MultiIPNormalDomain',
    value: (sep = ';', msg = i18n.t('common.enterValidDomainIPSemicolon')) => {
      const validator = (_, value, cb) => {
        const valueStr = String(value)
        if (valueStr) {
          const valueList = valueStr.split(sep)
          if (valueList.every(n => findReg('NormalDomain').test(n) || findReg('IP').test(n))) {
            cb()
          } else {
            cb(new Error(msg))
          }
        } else {
          cb()
        }
      }
      return { validator }
    }
  },
  {
    name: 'MultiIPOrSingleDomain',
    value: (sep = ';') => {
      const validator = (_, value, cb) => {
        const valueStr = String(value)
        let msg = ''
        if (valueStr) {
          const valueList = valueStr.split(sep).filter(item => !!item)
          const ipFag = valueList.some(n => findReg('IP').test(n))
          const domainFlag = valueList.some(n => findReg('StrictDomain').test(n))
          if (!ipFag && !domainFlag) {
            msg = i18n.t('domainManage.errorDomainAndIp')
          }
          if (!msg && ipFag && domainFlag) {
            msg = i18n.t('domainManage.errorBothDomainIp')
          }
          console.log(domainFlag, ipFag)
          if (!msg && domainFlag && valueList.length > 1) {
            msg = i18n.t('domainManage.oneDomainPermitted')
            if (!valueList.every(n => findReg('StrictDomain').test(n))) {
              msg = i18n.t('domainManage.errorDomain')
            }
          }
          if (!msg && ipFag && !valueList.every(n => findReg('IP').test(n))) {
            msg = i18n.t('domainManage.errorIp')
          }
        }
        if (msg) {
          return cb(new Error(msg))
        }
        cb()
      }
      return { validator }
    }
  },
  {
    name: 'MultiNormalDomain',
    value: (sep = ';', domainLen = 70, num=100) => {
      const validator = (_, value, cb) => {
        const valueStr = String(value)
        let msg = ''
        if (valueStr) {
          const valueList = valueStr.split(sep).filter(item => !!item)
          const lenFlag = valueList.every(n => n.length <= domainLen)
          const numFlag = valueList.length <= num
          const formatFlag = valueList.every(n => findReg('NormalDomain').test(n))
          const duplicate = (new Set(valueList)).size < valueList.length
          if (!lenFlag) msg = i18n.t('domainManage.maxStringLen', { num: domainLen })
          if (!numFlag) msg = i18n.t('domainManage.domainMaxNum', { num: num })
          if (!formatFlag) msg = i18n.t('domainManage.errorDomain')
          if (duplicate) msg = i18n.t('domainManage.domainDuplicate')
        }
        if (msg) {
          return cb(new Error(msg))
        }
        cb()
      }
      return{
        validator,
        tigger: 'blur'
      }
    }
  },
  // 输入多个端口，多个用sep分隔
  {
    name: 'MultiPort',
    value: (sep = ';', msg = i18n.t('common.enterValidPort')) => {
      const validator = (_, value, cb) => {
        const valueStr = String(value)
        if (valueStr) {
          const valueList = valueStr.split(sep)
          if (valueList.every(n => findReg('Port').test(n))) {
            cb()
          } else {
            cb(new Error(msg))
          }
        } else {
          cb()
        }
      }
      return { validator }
    }
  },
  // 输入多个IP，多个用sep分隔
  {
    name: 'MultiIP',
    value: (sep = ';', msg = i18n.t('common.enterValidIP')) => {
      const validator = (_, value, cb) => {
        const valueStr = String(value)
        if (valueStr) {
          const valueList = valueStr.split(sep)
          if (valueList.every(n => findReg('IP').test(n))) {
            cb()
          } else {
            cb(new Error(msg))
          }
        } else {
          cb()
        }
      }
      return { validator }
    }
  },
  {
    name: 'PatternSlash',
    value: {
      message: i18n.t('common.formatError'),
      pattern:findReg('SlashStart'),
      trigger: 'blur'
    }
  },
  // 多个sep分隔，每个值都要以 / 开头
  {
    name: 'StartsWithSlash',
    value: (valTrim = true, sep = '\n', msg = i18n.t('common.formatError')) => {
      const reg = findReg('SlashStart')
      const validator = (_, value, cb) => {
        if (valTrim) {
          const valueList = value.split(sep)
          if (valueList.every(n => !!n && reg.test(n))) {
            cb()
          } else {
            cb(new Error(msg))
          }
        } else {
          if (reg.test(value)) {
            cb()
          } else {
            cb(new Error(msg))
          }
        }
      }
      return { validator }
    }
  },
  // 多个sep分隔，每个值都要以 / 开头 并且以 / 结尾
  {
    name: 'StartsEndsSlash',
    value: (valTrim = true, sep = '\n', msg = i18n.t('common.formatError')) => {
      const reg = findReg('SlashStartEnd')
      const validator = (_, value, cb) => {
        if (valTrim) {
          const valueList = value.split(sep)
          if (valueList.every(n => !!n && reg.test(n))) {
            cb()
          } else {
            cb(new Error(msg))
          }
        } else {
          if (reg.test(value)) {
            cb()
          } else {
            cb(new Error(msg))
          }
        }
      }
      return { validator }
    }
  },
  // 正数字
  {
    name: 'PositiveNumber',
    value: (msg = i18n.t('common.formatError')) => {
      const reg = findReg('ValidNum')
      const validator = (_, value, cb) => {
        if (!reg.test(value)) {
          cb(new Error(msg))
        } else {
          if (parseFloat(value) > 0) {
            cb()
          } else {
            cb(new Error(msg))
          }
        }
      }
      return { validator }
    }
  },
  // 正整数（包含0）
  {
    name: 'PositiveIntegerAnd0',
    value: (msg = i18n.t('common.enterNum')) => {
      return {
        pattern: findReg('PositiveIntAnd0'),
        message: msg
      }
    }
  },
  // 正整数（不包含0）
  {
    name: 'PositiveInteger',
    value: (msg = i18n.t('common.enterPosInt')) => {
      return {
        pattern: findReg('PositiveInt'),
        message: msg
      }
    }
  },
  {
    name: 'Num',
    value: (msg = i18n.t('common.formatError')) => {
      const validator = (_, value, cb) => {
        if (value) {
          if (isNaN(value * 1)) {
            cb(new Error(msg))
          } else {
            cb()
          }
        } else {
          cb()
        }
      }
      return { validator }
    }
  },
  // 正整数范围
  {
    name: 'IntegerRange',
    value: (min = 0, max = 100) => {
      const validator = (_, value, cb) => {
        const num = Number(value)
        if(typeof num === 'number') {
          if (num >= min && num <= max && Number.isInteger(num)) {
            cb()
          } else {
            cb(new Error(i18n.t('common.validRange', { min, max })))
          }
        } else {
          cb(new Error(i18n.t('common.formatError')))
        }
      }
      return { validator }
    }
  },
  // 数字范围
  {
    name: 'NumberRange',
    value: (min = 0, max = 100) => {
      const validator = (_, value, cb) => {
        const num = Number(value)
        if(typeof num === 'number') {
          if (num >= min && num <= max) {
            cb()
          } else {
            cb(new Error(i18n.t('common.validRange', { min, max })))
          }
        } else {
          cb(new Error(i18n.t('common.formatError')))
        }
      }
      return { validator }
    }
  },
  // 校验不重复，value可以是数组，或者是字符串，字符串以sep分隔
  {
    name: 'NoRepeat',
    value: (sep = '\n', msg = i18n.t('common.duplicateContent')) => {
      const validator = (_, value, cb) => {
        if (isArray(value)) {
          if (typeof value[0] === 'string' || typeof value[0] === 'number') {
            // 字符串/数字 数组
            const valueList = value.filter(Boolean)
            const uniqList = uniq(valueList)
            if (uniqList.length === value.length) {
              cb()
            } else {
              cb(new Error(msg))
            }
          } else {
            // 复杂类型，暂时不校验，等需要再补充
            cb()
          }
        } else if (typeof value === 'string') {
          const valueList = value.split(sep).filter(Boolean)
          const uniqList = uniq(valueList)
          if (valueList.length === uniqList.length) {
            cb()
          } else {
            cb(new Error(msg))
          }
        } else {
          cb()
        }
      }
      return { validator }
    }
  },
  // 文本框输入指定长度内容
  {
    name: 'InputLen',
    value: (len = 4, msg = i18n.t('common.lenError')) => {
      const validator = (_, value, cb) => {
        if (value?.length !== len) {
          cb(new Error(msg))
        } else {
          cb()
        }
      }
      return { validator }
    }
  },
  // 文本框输入指定长度内容
  {
    name: 'MaxStringLen',
    value: (len = 70, msg) => {
      msg = msg || i18n.t('domainManage.maxStringLen', { num: len })
      const validator = (_, value, cb) => {
        if (value?.length > len) {
          cb(new Error(msg))
        } else {
          cb()
        }
      }
      return { validator }
    }
  },
  // 文本框输入不少于x位
  // 用户密码不能少于12位这是uca那边的限制
  {
    name: 'InputAtLeaseLen',
    value: (len = 8, msg = i18n.t('common.lenError')) => {
      const validator = (_, value, cb) => {
        if (value?.length < len) {
          cb(new Error(msg))
        } else {
          cb()
        }
      }
      return { validator }
    }
  },
  // 邮箱
  {
    name: 'Email',
    value: (msg = i18n.t('common.errorEmailFormat')) => {
      return {
        pattern: findReg('Email'),
        message: msg
      }
    }
  },
  // 验证手机号
  {
    name: 'PhoneWithCode',
    value: (code, msg = i18n.t('common.phoneError')) => {
      const validator = (_, value, cb) => {
        if (value) {
          const reg = code === '0086' ? /^1[3456789]\d{9}$/ : /^\d{7,11}$/
          if (reg.test(value)) {
            cb()
          } else {
            cb(new Error(msg))
          }
        } else {
          cb()
        }
      }
      return { validator }
    }
  },
  // 中英文数字下划线
  {
    name: 'EN-CN-Num_',
    value: (msg = i18n.t('common.enCnNum_')) => {
      return {
        pattern: findReg('EnCnNum_'),
        message: msg
      }
    }
  },
  // 登录密码：不允许空格，不允许中文，必须包含以下四类中至少三类
  // 1.数字，2.小写字符，3.大写字母，4.特殊字符
  {
    name: 'UserPassword',
    value: (msg = i18n.t('common.formatError')) => {
      const validator = (_, value, cb) => {
        const null_reg = new RegExp(/\s+/) //不含空格
        const hex_reg = new RegExp(/[\u4e00-\u9fa5]+/)
        const num_reg = new RegExp(/\d+/) //包含数字
        const upper_char_reg = new RegExp(/[A-Z]+/) //包含大写字母
        const lower_char_reg = new RegExp(/[a-z]+/) //包含小写字母
        const sp_char_reg = new RegExp(/[`~!@#$%^&*()\-=+{}[]|;:'",.<>\/?_^]+/)
        let count = 0
        if (!null_reg.test(value) && !hex_reg.test(value)) {
          if (num_reg.test(value)) {
            count ++
          }
          if (lower_char_reg.test(value)) {
            count ++
          }
          if (upper_char_reg.test(value)) {
            count ++
          }
          if (sp_char_reg.test(value)) {
            count ++
          }
          if (count >= 3) {
            cb()
          } else {
            cb(new Error(msg))
          }
        } else {
          cb(new Error(msg))
        }
      }
      return { validator }
    }
  },
  // 两次输入一致
  {
    name: 'TheSame',
    value: (target, msg = i18n.t('common.confirmPasswordError')) => {
      const validator = (_, value, cb) => {
        if (value === target) {
          cb()
        } else {
          cb(new Error(msg))
        }
      }
      return { validator }
    }
  },
  // 两次输入一致
  {
    name: 'MultiItemNum',
    value: (num = 50, split=';') => {
      const validator = (_, value, cb) => {
        const msg = i18n.t('common.maxItemNum', { num:num })
        const items = value.split(split)
        if (items.length <= num) {
          cb()
        } else {
          cb(new Error(msg))
        }
      }
      return { validator }
    }
  },
  {
    name: 'MaxBytes',
    value: (maxBytes = 4096) => {
      const msg = i18n.t('domainManage.bytesExceed', { num: maxBytes })
      const validator = (_, value, cb) => {
        if (typeof value === 'string') {
          // 计算字节长度
          const byteLen = encodeURIComponent(value).replace(/%[A-F\d]{2}/g, 'U').length
          if (byteLen > maxBytes) {
            cb(new Error(msg))
          } else {
            cb()
          }
        } else {
          cb()
        }
      }
      return { validator }
    }
  }
]
